import React from 'react';
import Carousel from 'react-multi-carousel';

const AdsCarousel = ({slidesData, miroLink}) => {
  const responsiveValue = {
    lg: {
      breakpoint: {
        max: Number.MAX_SAFE_INTEGER,
        min: 1201,
      },
      items: 1,
      partialVisibilityGutter: 40,
      slidesToSlide: 1,
    },
    md: {
      breakpoint: {
        max: 1200,
        min: 769,
      },
      items: 1,
      partialVisibilityGutter: 30,
      slidesToSlide: 1,
    },
    sm: {
      breakpoint: {
        max: 768,
        min: 0,
      },
      items: 1,
      partialVisibilityGutter: 30,
      slidesToSlide: 1,
    },
  };
  if (!slidesData) {
    return <div>No slides to display</div>;
  }
  return (
    <div className="ads-art-carousel">
      <div className="ads-art-carousel-section">
        <Carousel
          additionalTransfrom={0}
          arrows
          autoPlay
          autoPlaySpeed={6000}
          customTransition="transform 800ms ease-out"
          transitionDuration={800}
          centerMode={false}
          draggable
          focusOnSelect={false}
          infinite
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={false}
          renderDotsOutside
          responsive={responsiveValue}
          slidesToSlide={1}
          swipeable
          ssr
        >
          {slidesData.map((value, index) => (
            <>
              <p className="ads-art-slide-num">
                {index + 1}/{slidesData.length}
              </p>
              <div className="art-ads-slide-section" key={value.id}>
                <img className="art-ads-slide-img" src={value.img} alt="" />
                <video className="art-ads-slide-video" controls autoPlay muted loop>
                  <track kind="captions" />
                  <source src={value.vid} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </>
          ))}
        </Carousel>
        <div className="art-storyboard-btn-section">
          <a href={miroLink} target="_blank" rel="noreferrer">
            <button type="button" className="art-storyboard-button">
              Full Storyboard
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdsCarousel;
